<div *ngIf="sheet_ready">
  <processSheetView [propertyCategories]="property_categories"
                    [allProcesses]="allProcesses"
                    [processes]="processes"
                    [parent]="parent"
                     ></processSheetView>
</div>
